export default function getInitState() {
    return {
        appointmentsIsShow: true,
        attendanceIsShow: false,
        appointmentObject: undefined
    }
}
